import { createAsyncThunk } from '@reduxjs/toolkit';

const getTemplates = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/templates');
    return result;
  } catch (error) {
    throw error;
  }
};

const getTemplateById = async ({ templateId }, { extra: { http } }) => {
  try {
    const result = await http.get(`/templates/${templateId}`);
    return result;
  } catch (error) {
    throw error;
  }
};

const onSaveTemplate = async ({ subject, body, name }, { extra: { http } }) => {
  try {
    const result = await http.post('/templates', {
      template: { subject, body, name },
    });
    return result;
  } catch (error) {
    throw error;
  }
};

const onFetchVariables = async (_, { extra: { http } }) => {
  try {
    const result = await http.get('/templates/variables');
    return result;
  } catch (error) {
    throw error;
  }
};

export const fetchTemplates = createAsyncThunk(
  'templates/fetch/all',
  getTemplates
);

export const fetchTemplateById = createAsyncThunk(
  'templates/fetch/byId',
  getTemplateById
);

export const saveTemplate = createAsyncThunk('templates/save', onSaveTemplate);

export const fetchVariables = createAsyncThunk(
  'templates/variables',
  onFetchVariables
);
